import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecpl-status-bar',
  templateUrl: './status-bar.component.html',
  styles: [
    `
      .panel {
        margin-bottom: 0px;
        border-radius: 0px;
      }
    `
  ],
  standalone: false
})
export class StatusBarComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
